import { useSelector } from 'react-redux';
import UtilObject from '../utils/UtilObject';
import { useLocation, Navigate } from 'react-router-dom';
import { getLocalizedPath } from '../i18nLanguages';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const currentUser = useSelector((state) => state.currentUser);

  const isEmpty = UtilObject.isEmpty(currentUser);

  if (isEmpty) {
    return (
      <Navigate
        to={getLocalizedPath('/login', location.pathname)}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
